import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Crown, AlertCircle } from 'lucide-react';
import { SubscriptionSection } from '../components/billing/SubscriptionSection';
import { useAuth } from '../contexts/AuthContext';
import { useSubscriptionStatus } from '../hooks/useSubscriptionStatus';

const SubscriptionRequiredPage = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const { hasActiveSubscription, loading } = useSubscriptionStatus();

  // Get the intended destination
  const from = (location.state as any)?.from?.pathname || '/select-project';

  // Check if subscription is now active and redirect
  useEffect(() => {
    if (!loading && hasActiveSubscription) {
      navigate(from, { replace: true });
    }
  }, [hasActiveSubscription, loading, navigate, from]);

  return (
    <div className="min-h-screen bg-white dark:bg-neutral-950 text-neutral-900 dark:text-white">
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold">Unlock Your Project's Potential</h1>
        </div>

        {/* Message */}
        <div className="max-w-3xl mx-auto mb-8">
          <p className="text-xl text-neutral-700 dark:text-neutral-300 text-center">
            We hope you've enjoyed your trial. To continue using KolegaStudio, you need to choose a plan.
          </p>
        </div>

        {/* Error Message */}
        {error && (
          <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-8">
            <p className="text-sm text-red-800 dark:text-red-200">{error}</p>
          </div>
        )}

        {/* Subscription Selection */}
        <div className="bg-neutral-50 dark:bg-neutral-900 rounded-lg p-6">
          <SubscriptionSection />
        </div>
      </div>
    </div>
  );
};

export default SubscriptionRequiredPage; 